import Register from "./components/Register";
import ipConfig from "./ipConfig.json";
// import { Route, Switch } from "react-router-dom";
import Login from "./components/Login";
import Products from "./components/Products";
import React from "react";
import { ThemeProvider } from "@mui/system";
import theme from './theme'
import {BrowserRouter,Switch,Route} from 'react-router-dom'
import Checkout from "./components/Checkout"
import Thanks from "./components/Thanks"

export const config = {
  endpoint: `https://rkganeshan-qkart-frontend.herokuapp.com/api/v1`,
};
// http://13.233.239.204:8082/api/v1/auth/register
function App() {
  return (
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <div className="App">
        <BrowserRouter>
        <Switch>
            <Route path="/" exact component={Products}/>
            <Route path="/register" exact component={Register}/>
            <Route path="/login" exact component={Login}/>
            <Route path="/checkout" exact component={Checkout}/>
            <Route path="/thanks" exact component={Thanks}/>
            </Switch>
        </BrowserRouter>
        </div>
      </ThemeProvider>
    </React.StrictMode>
    
  );
}

export default App;
